<div class="container-fluid">
    <div class="my-3">
      <h3>Create an Account</h3>
      <div class="row mt-3" *ngIf="showBusinessWizard || showPersonalWizard">
        <div class="col-12">
            ( <span class="text-danger"> * </span> ) Required Information
        </div>
      </div>
      <div class="row my-4">
        <div *ngIf="!showBusinessWizard && !showPersonalWizard" class="offset-lg-4 col-lg-4 col-12">
          <h5 class="text-center">What kind of account are you registering for?</h5>
          <button class="btn text-light bg-altec w-100" (click)="showBusinessWizard = true">Business</button>
          <h5 class="text-center my-2">or</h5>
          <button class="btn text-light bg-altec w-100" (click)="showPersonalWizard = true">Personal</button>
          <div class="alert alert-light border registration-disclaimer mt-4 mb-0" role="alert">
            Please note, this is <strong>NOT</strong> a login to bid at our auctions or register with Proxibid.
            This registration is for repeat buyers who want to view their past invoices and/or for active sellers
            who want to view their current/past inventory sales through JJ Kane. For further questions or information,
            please contact us by phone: <a href="tel:+18567647163">(856) 764-7163</a> or
            email: <a href="mailto:contact@jjkane.com">contact&#64;jjkane.com</a>
          </div>
        </div>
      </div>
      <div *ngIf="showBusinessWizard">
        <app-business-wizard></app-business-wizard>
      </div>
      <div *ngIf="showPersonalWizard">
        <app-personal-wizard></app-personal-wizard>
      </div>
    </div>
</div>
